export default __webpack_public_path__ + "static/media/alayuni.39b580d8.png";